var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_192_67865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.2334C9.5 6.40497 10.1716 5.7334 11 5.7334H68.0001C68.8286 5.7334 69.5001 6.40497 69.5001 7.2334V78.5236C69.5001 79.352 68.8286 80.0236 68.0001 80.0236H11C10.1716 80.0236 9.5 79.352 9.5 78.5236V7.2334Z",
    fill: "white",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7.2334C9 6.12883 9.89543 5.2334 11 5.2334H68.0001C69.1047 5.2334 70.0001 6.12883 70.0001 7.2334V78.5236C70.0001 79.6282 69.1047 80.5236 68.0001 80.5236H11C9.89543 80.5236 9 79.6282 9 78.5236V7.2334Z",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6319 31.5394H20.6613C19.6745 31.5394 18.8672 30.723 18.8672 29.7252V20.6541C18.8672 19.6562 19.6745 18.8398 20.6613 18.8398H29.6319C30.6187 18.8398 31.426 19.6562 31.426 20.6541V29.7252C31.426 30.723 30.6187 31.5394 29.6319 31.5394Z",
    fill: "#C7CBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6319 49.6822H20.6613C19.6745 49.6822 18.8672 48.8658 18.8672 47.868V38.7969C18.8672 37.7991 19.6745 36.9827 20.6613 36.9827H29.4525C30.529 36.9827 31.426 37.8898 31.426 38.9783V47.868C31.426 48.8658 30.6187 49.6822 29.6319 49.6822Z",
    fill: "#C7CBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6319 67.8241H20.6613C19.6745 67.8241 18.8672 67.0077 18.8672 66.0098V56.9387C18.8672 55.9409 19.6745 55.1245 20.6613 55.1245H29.6319C30.6187 55.1245 31.426 55.9409 31.426 56.9387V66.0098C31.426 67.0077 30.6187 67.8241 29.6319 67.8241Z",
    fill: "#C7CBDC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7266 62.793L48.9503 62.7807",
    stroke: "#A4ABC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7148 57.2437L58.5143 57.1959",
    stroke: "#A4ABC0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6875 45.0127L48.9113 45.0004",
    stroke: "#A4ABC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6738 39.4634L58.4732 39.4157",
    stroke: "#A4ABC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6465 27.1191L48.8702 27.1069",
    stroke: "#A4ABC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6348 21.5703L58.4342 21.5226",
    stroke: "#A4ABC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_192_67865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8908 41.7649L55.5218 68.4388L41.7044 73.3354L46.5418 59.3616L72.9109 32.6877L81.8908 41.7649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5516 59.4095L72.9331 32.7232L81.912 41.7993L55.5303 68.4856L46.5516 59.4095Z",
    fill: "#FFC043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8094 67.2352L41.7061 73.1936L47.5978 71.0647L43.8094 67.2352Z",
    fill: "#8A90A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8908 41.7649L55.5218 68.4388L41.7044 73.3354L46.5418 59.3616L72.9109 32.6877L81.8908 41.7649Z",
    stroke: "#999BA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.891 41.7648L86.0988 37.5083C87.291 36.3023 87.2907 34.3873 86.0981 33.2526L81.3275 28.4304C80.1348 27.2248 78.241 27.2252 77.1189 28.4312L72.9111 32.6876L81.891 41.7648Z",
    fill: "#F4B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.891 41.7648L86.0988 37.5083C87.291 36.3023 87.2907 34.3873 86.0981 33.2526L81.3275 28.4304C80.1348 27.2248 78.241 27.2252 77.1189 28.4312L72.9111 32.6876L81.891 41.7648Z",
    stroke: "#999BA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2904 58.295L78.7347 39.6375",
    stroke: "#999BA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8562 65.8149L57.1342 61.4875",
    stroke: "#999BA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8346 34.8783L74.5042 31.1663L83.4831 40.2424L79.8135 43.9544L70.8346 34.8783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8346 34.8783L74.5042 31.1663L83.4831 40.2424L79.8135 43.9544L70.8346 34.8783Z",
    stroke: "#999BA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_192_67865",
    x: 0.5,
    y: 0.733398,
    width: 78,
    height: 92.2903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.192157 0 0 0 0 0.364706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_192_67865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_192_67865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_192_67865",
    x: 32.7051,
    y: 22.5264,
    width: 63.2871,
    height: 63.8091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.192157 0 0 0 0 0.364706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_192_67865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_192_67865",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateList);
export default __webpack_public_path__ + "static/media/create-list.a2f40b1afeedeecade8a614031ab5a65.svg";
export { ForwardRef as ReactComponent };